import {
  QueryClient,
  QueryClientProvider as InnerProvider,
} from '@tanstack/react-query';

export const queryClient = new QueryClient();

export const QueryClientProvider = ({ children }) => (
  <InnerProvider client={queryClient}>{children}</InnerProvider>
);
